import React, { useContext, useEffect, useState } from 'react';
import { BeginnerMode, GameSettings, HobbyistMode, ProMode } from '../../../settings/modes';
import { GameSettingsContext } from '../../../providers/GameSettingProvider';
import styled from 'styled-components';
import { beigeColor } from '../../../styles/GlobalStyle';
import { useTranslation } from 'react-i18next';
import { YsdkContext } from '../../../yandex-add/YsdkProvider';
import { TILE_SIZE_LARGE } from '../../../styles/global';

const optionsLevel = [
	{ title: 'Beginner', mode: BeginnerMode },
	{ title: 'Intermediate', mode: HobbyistMode },
	{ title: 'Expert', mode: ProMode },
];

const Select = styled.select`
  display: block;
  font-size: 1.5vmin;
  border: none;
  background-color: ${beigeColor};
  margin: 0 0.5vmin;
  appearance: none;
  padding: 0 1vmin;
`;
const modes: GameSettings[] = [BeginnerMode, HobbyistMode, ProMode];
export const DropdownLevel = () => {
	const { t } = useTranslation();
	const { setGameSettings } = useContext(GameSettingsContext);
	const setMode = (mode: GameSettings): void => setGameSettings(mode);

	return (
		<Select
			onChange={e => setMode(modes[+e.target.value])}
			defaultValue={1}
		>
			{optionsLevel.map((option, index) => (
				<option key={option.title} value={index}>{t(option.title)}</option>))}
		</Select>
	);
};

const optionsLanguage = [
	{ title: 'Türkçe', mode: 'tr' },
	{ title: 'Русский', mode: 'ru' },
	{ title: 'English', mode: 'en' },
];

export const DropdownLanguage = () => {
	const { i18n } = useTranslation();
	const ysdk = useContext(YsdkContext);
	const [def, setDef] = useState(ysdk?.environment?.i18n.lang);

	const changeLanguage = (language: string): void => {
		i18n.changeLanguage(language).then();
	};

	useEffect((): void => {
		setDef(ysdk?.environment?.i18n.lang);
	}, [ysdk]);

	return (
		<Select
			onChange={e => changeLanguage(e.target.value)}>
			{optionsLanguage.map((option) => (
				<option selected={option.mode === def} key={option.mode} value={option.mode}>{option.title}</option>))}
		</Select>
	);
};
